import { Button, Input, Spin } from "antd";
import React from "react";
import '../styles/FormInput.css';

const FormInput = (props) => {
    return (
        <div className="form-input-container">
            <div className="form-label">
                {props.label}
            </div>
            <div className={props.buttonLabel ? "input-field-container margin-r-10" : "input-field-container"}>
                <Input variant="filled" {...props} />
                {props.buttonLabel ? <Button style={{backgroundColor:'#5f0a10',color:'white'}} onClick={props.onButtonClick}>{props.isButtonLoading ? <Spin/> : props.buttonLabel}</Button> : <></>}
            </div>
        </div>
    )
}
export default FormInput;